export const initialProductState = {
  products: [],
  product: null,
  productLists: [],
  status: 'idle',
  error: { message: null }, // Error as an object for consistency
};
